var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "\n  sw-model-fix-app\n  sw-grid-flex\n  sw-grid-flex--dir-row-reverse\n  sw-grid-flex--dir-column--tab\n  sw-grid-flex--wrap--tab\n  sw--padding-hor-12 sw--padding-vert-8"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "sw-grid-flex__cell-2-3 sw-grid-flex__cell-1-1--tab sw--padding-left-5 sw--padding-left-0--tab"
        },
        [
          _c("div", { staticClass: "sw--height-full" }, [
            _c(
              "div",
              { staticClass: "sw-grid-flex--cell", attrs: { role: "tablist" } },
              [
                _c("h1", [_vm._v("Update your model")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "It looks like there was a design issue with your model "
                  ),
                  _c("span", { staticClass: "italic" }, [
                    _vm._v(_vm._s(_vm.modelName))
                  ]),
                  _vm._v(
                    ". The areas of the model\n          that need review are highlighted on the left. Please use this information and one of the options below to\n          decide on how to proceed with this model. Note that the estimated ship date may change depending on what\n          action is taken."
                  )
                ]),
                _vm._v(" "),
                _vm.letUsFixEnabled
                  ? _c("model-fix-let-us-fix", {
                      attrs: {
                        url: _vm.letUsFixUrl,
                        accordionId: "accordion-1",
                        accordionGroup: "update-model"
                      },
                      on: { success: _vm.letUsFixSuccess }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("accordion", {
                  attrs: { id: "accordion-2", group: "update-model" },
                  scopedSlots: _vm._u([
                    {
                      key: "trigger",
                      fn: function() {
                        return [
                          _c("span", {
                            staticClass:
                              "icon-models sw--margin-right-3 sw--font-size-20"
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Fix your model")])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "target",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "sw--margin-bottom-7 sw--margin-left-7 sw--margin-left-0--tab"
                            },
                            [
                              _vm.showUpload
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "sw--margin-bottom-2 sw-dms--color-grey-46"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Repair the affected areas of the model yourself, and upload the new file using the area below. Our\n                  system will process your file, then move the model into our review process. Once a new model is\n                  uploaded, Print it Anyway will not be available for this model.\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("model-fix-drag-and-drop-upload", {
                                      attrs: {
                                        uploadAction: _vm.uploadAction,
                                        appId: _vm.appId,
                                        acceptedModelExtensions:
                                          _vm.acceptedModelExtensions,
                                        maxUploadSize: _vm.maxUploadSize,
                                        scaleMillimeters: _vm.scaleMillimeters,
                                        scaleMeters: _vm.scaleMeters,
                                        scaleInches: _vm.scaleInches,
                                        showDesignWithShapeways:
                                          _vm.showDesignWithShapeways,
                                        designWithShapewaysUrl:
                                          _vm.designWithShapewaysUrl,
                                        confirmBeforeUpload:
                                          _vm.confirmBeforeUpload
                                      },
                                      on: {
                                        success: _vm.uploadSuccess,
                                        error: _vm.uploadError
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.confirmErrorMessage
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "sw-model-material-drag-and-drop-upload__content"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sw-grid-flex__cell\n                    sw-grid-flex\n                    sw-grid-flex--align-center\n                    sw--padding-4\n                    sw--bg-alert-red-lightest\n                    sw--border-radius-3\n                    sw--position-relative\n                    sw--margin-top-2"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "icon-how-it-works sw--font-size-28 sw--margin-right-3 sw--text-red"
                                                }),
                                                _vm._v(" "),
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.confirmErrorMessage
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "sw-model-material-drag-and-drop-upload__content-error-spacer"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm.showAnalyzing
                                ? [_c("model-fix-analyzing-model")]
                                : _vm.showConfirmUploaded
                                ? [
                                    _c("model-fix-confirm-uploaded-model", {
                                      attrs: { confirmUrl: _vm.confirmUrl },
                                      on: {
                                        success: _vm.confirmedUploadedModel,
                                        cancel: _vm.cancelUploadedModel,
                                        error: _vm.errorConfirmUploadedModel
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("model-fix-pita", {
                  attrs: {
                    enabled: _vm.pitaEnabled,
                    url: _vm.pitaUrl,
                    accordionId: "accordion-3",
                    accordionGroup: "update-model"
                  },
                  on: { success: _vm.pitaSuccess }
                }),
                _vm._v(" "),
                _c("model-fix-cancel-order-items", {
                  attrs: {
                    url: _vm.cancelUrl,
                    accordionId: "accordion-4",
                    accordionGroup: "update-model"
                  },
                  on: { success: _vm.canceledOrderItem }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "\n    sw-grid-flex__cell\n    sw--padding-right-5\n    sw--padding-right-0--tab\n    sw-model-fix-app-aside"
        },
        [
          _vm.showSlideshow
            ? _c(
                "div",
                [
                  _c("model-fix-slideshow", {
                    attrs: { modelName: _vm.modelName, slides: _vm.slides }
                  })
                ],
                1
              )
            : _vm.showGrayRenderViz
            ? [
                _c("model-fix-gray-render-viz", {
                  attrs: {
                    grayRenderVizStatus: _vm.grayRenderVizStatus,
                    aoptPath: _vm.aoptPath,
                    glbPath: _vm.glbPath,
                    pictureUrl: _vm.pictureUrl
                  }
                }),
                _vm._v(" "),
                _c("model-fix-dimensions", {
                  attrs: {
                    "model-dimensions": _vm.modelDimensions,
                    "pricing-dimensions": _vm.pricingDimensions
                  }
                })
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }